import { useMemo } from 'react'
import {
  TTimeline,
  TTimelineMedEventElement,
  TTimelineElement,
  ETimelineElementType,
} from './followup-timeline.type'
import { compareIsoDurations } from '../messages/_components/programmed-message.helper'
import { useSelfConfigurationFollowup } from './use-self-configuration-followup.hook'

export const useSortedFollowupTimeline = (followupId: string | undefined) => {
  const { isLoading, error, data: followupTimeline } = useSelfConfigurationFollowup(followupId)

  const timelineMedEventsSorted = useMemo<TTimeline>(() => {
    if (!followupTimeline?.timelineMedEvents) return []

    return followupTimeline.timelineMedEvents.map((timelineMedEvent) => {
      const messagesBeforeMedEvents: TTimelineElement[] = timelineMedEvent.messages
        .filter((message) => message.schedule.durationDiff.startsWith('-'))
        .sort((messageA, messageB) =>
          compareIsoDurations(messageB.schedule.durationDiff, messageA.schedule.durationDiff),
        )

      const messagesAfterMedEvents: TTimelineElement[] = timelineMedEvent.messages
        .filter((message) => !message.schedule.durationDiff.startsWith('-'))
        .sort((messageA, messageB) =>
          compareIsoDurations(messageB.schedule.durationDiff, messageA.schedule.durationDiff),
        )

      const medEventItem: TTimelineMedEventElement = {
        type: ETimelineElementType.MED_EVENT,
        medEventLabel: timelineMedEvent.label,
        formConfiguration: timelineMedEvent.formConfiguration,
      }

      return [...messagesAfterMedEvents, medEventItem, ...messagesBeforeMedEvents]
    })
  }, [followupTimeline])

  return { isLoading, error, followupTimeline, timelineMedEventsSorted }
}
